import React, {useEffect, useState} from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Spin, Typography, notification, Alert, Button } from 'antd';
import { LoadingOutlined, CheckCircleOutlined, CloseOutlined } from '@ant-design/icons';
import Driver from '../components/drivers/Driver';

const { Title } = Typography;

const DriversList = () => {
  const [error, setError] = useState(false);
  const [drivers, setDrivers] = useState(null);
  const [loading, setLoading] = useState(null);
  const [api, contextHolder] = notification.useNotification();

  const openNotification = (driver) => {
    api.open({
      message: `Водитель ${driver.username} удален!`,
      icon: <CheckCircleOutlined style={{ color: '#108ee9' }} />,
    });
  };

  const deleteDriver = async (driver) => {
    setLoading(true);
    try { 
      await axios.delete(`${process.env.REACT_APP_API_URL}/auth/users/${driver.id}`, {
        headers: {
          Authorization: `JWT ${window.localStorage.getItem('access')}`
        }
      });
      await fetchList();
      openNotification(driver);
    } catch (error) {
      if (error.response.data.detail) {
        setError(error.response.data.detail);
      } else {
        setError('Ошибка при удалении, попробуйте позже'); 
      }
      setLoading(false);
    }
  };

  const fetchList = async () => {
    setLoading(true);
    setDrivers(null)
    try {
      const { data, status } = await axios.get(`${process.env.REACT_APP_API_URL}/auth/users/`, {
        headers: {
          Authorization: `JWT ${window.localStorage.getItem('access')}`
        }
      });
      setLoading(false);
      if (status === 200) {
        setDrivers(data);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchList();
  }, []);

  return (
    <div className='page drivers-list'>
      <Link to='/' className='close-page'>
        <CloseOutlined
          style={{
            fontSize: 42,
            color: '#333'
          }}
        />
      </Link>
      {contextHolder}
      <div className='wrapper'>
        <Title>Список Водителей</Title>
        {error && <div>
          <Alert
            message={error}
            type="error"
            showIcon
          />
          <br/>
        </div>}
        {loading && <Spin
          indicator={
            <LoadingOutlined
              style={{
                fontSize: 32,
              }}
              spin
            />
          }
        />}
        <div className='create-drive'>
          <Button type='primary' href='/drivers/create'>Создать Водителя</Button>
        </div>
        {drivers && drivers.length > 0 && drivers.map(driver => {
          return (
            <Driver key={driver.id} driver={driver} deleteDriver={deleteDriver} />
          )
        })}
      </div>
    </div>
  )
}

export default DriversList;